import React, {Component} from "react";
import {connect} from "react-redux";
import ReactSelect, {components} from "react-select";
import {
  setEventStatsSaison
} from "../../../actions/actions/eventStats";
import StartMonthFilter from "./StartMonthFilter";
import EndMonthFilter from "./EndMonthFilter";


class MonthFilter extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showMenu: false,
    };
  }

  handleSelectChange = (value) => {
    this.props.setEventStatsSaison(value.value);
  }

  handleChevronClick = () => {
    this.setState({showMenu : !this.state.showMenu});
  }

  render() {

    return (
      <div className={'month-filter-container'}>
        <div className={'month-period ml-3'}>{this.props.eventStatsFilter.startMonthLabel} - {this.props.eventStatsFilter.endMonthLabel}</div>
        <div className={'ml-auto mr-3'}>
          <img src={"/img/icons/white-polygon.svg"} className={this.state.showMenu && 'chevron-rotate'} onClick={() => this.handleChevronClick()}/>
        </div>
        <div className={this.state.showMenu ? 'month-period-menu flex justify-center' : 'menu-not-displayed'}>
          <div>
            <div className={'month-label mb-4 mt-1'}>Début :</div>
            <div className={'month-label'}>Fin :</div>
          </div>
          <div className={'ml-3'}>
            <div>
              <StartMonthFilter/>
            </div>
            <div className={'mt-3'}>
              <EndMonthFilter/>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
});

const mapDispatchToProps = {
  setEventStatsSaison,
};

export default connect(mapStateToProps, mapDispatchToProps)(MonthFilter);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/MonthFilter.js